export default __webpack_public_path__ + "static/media/blob_bottom.85de3f6d.svg";